export default "__VITE_ASSET__CJhR48ie__$_?nuxt_component=async&nuxt_component_name=SvgoGooglePlay&nuxt_component_export=default__"